const map = {
	"./1.jpg": 145,
	"./10.jpg": 5645,
	"./11.jpg": 4400,
	"./12.jpg": 8127,
	"./13.jpg": 66,
	"./14.jpg": 5297,
	"./15.jpg": 3492,
	"./17.jpg": 9446,
	"./2.jpg": 2390,
	"./23.jpg": 5323,
	"./3.jpg": 5523,
	"./4.jpg": 9248,
	"./5.jpg": 1469,
	"./6.jpg": 5538,
	"./7.jpg": 7247,
	"./8.jpg": 8876,
	"./9.jpg": 3577
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2821;